let cachedLodash

function getLodashModule() {
  try {
    const pathToLodash = __non_webpack_require__.resolve('lodash')
    if (pathToLodash) { cachedLodash = __non_webpack_require__(pathToLodash) }
  } catch (error) {
    console.error('Attempt to wrap lodash module failed:')
    console.error(error)
  }

  if (cachedLodash) { return cachedLodash }

  if (typeof window !== 'undefined' && typeof window.lodash !== 'undefined') {
    cachedLodash = window.lodash
  } else if (typeof global !== 'undefined' && typeof global.lodash !== 'undefined') {
    cachedLodash = global.lodash
  } 

  return cachedLodash
}

export const lodashModules = (systemLodash) => {
  if (!systemLodash) { systemLodash = getLodashModule() }
  
  return Object.assign(systemLodash, {
    get lodashChain() { return systemLodash.chain },
    get lodashObject() { return systemLodash.pick(systemLodash, objectMethods) },
    get lodashCollection() { return systemLodash.pick(systemLodash, collectionMethods) },
    get lodashArray() { return systemLodash.pick(systemLodash, arrayMethods) }
  })
}

export default lodashModules

export const objectMethods = [
  "assign",
  "assignIn",
  "assignInWith",
  "assignWith",
  "at",
  "create",
  "defaults",
  "defaultsDeep",
  "entries",
  "entriesIn",
  "extend",
  "extendWith",
  "findKey",
  "findLastKey",
  "forIn",
  "forInRight",
  "forOwn",
  "forOwnRight",
  "functions",
  "functionsIn",
  "get",
  "has",
  "hasIn",
  "invert",
  "invertBy",
  "invoke",
  "keys",
  "keysIn",
  "mapKeys",
  "mapValues",
  "merge",
  "mergeWith",
  "omit",
  "omitBy",
  "pick",
  "pickBy",
  "result",
  "set",
  "setWith",
  "toPairs",
  "toPairsIn",
  "transform",
  "unset",
  "update",
  "updateWith",
  "values",
  "valuesIn"
]

export const arrayMethods = [
  "chunk",
  "compact",
  "concat",
  "difference",
  "differenceBy",
  "differenceWith",
  "drop",
  "dropRight",
  "dropRightWhile",
  "dropWhile",
  "fill",
  "findIndex",
  "findLastIndex",
  "first",
  "flatten",
  "flattenDeep",
  "flattenDepth",
  "fromPairs",
  "head",
  "indexOf",
  "initial",
  "intersection",
  "intersectionBy",
  "intersectionWith",
  "join",
  "last",
  "lastIndexOf",
  "nth",
  "pull",
  "pullAll",
  "pullAllBy",
  "pullAllWith",
  "pullAt",
  "remove",
  "reverse",
  "slice",
  "sortedIndex",
  "sortedIndexBy",
  "sortedIndexOf",
  "sortedLastIndex",
  "sortedLastIndexBy",
  "sortedLastIndexOf",
  "sortedUniq",
  "sortedUniqBy",
  "tail",
  "take",
  "takeRight",
  "takeRightWhile",
  "takeWhile",
  "union",
  "unionBy",
  "unionWith",
  "uniq",
  "uniqBy",
  "uniqWith",
  "unzip",
  "unzipWith",
  "without",
  "xor",
  "xorBy",
  "xorWith",
  "zip",
  "zipObject",
  "zipObjectDeep",
  "zipWith"
]

export const collectionMethods = [
  "countBy",
  "each",
  "eachRight",
  "every",
  "filter",
  "find",
  "findLast",
  "flatMap",
  "flatMapDeep",
  "flatMapDepth",
  "forEach",
  "forEachRight",
  "groupBy",
  "includes",
  "invokeMap",
  "keyBy",
  "map",
  "orderBy",
  "partition",
  "reduce",
  "reduceRight",
  "reject",
  "sample",
  "sampleSize",
  "shuffle",
  "size",
  "some",
  "sortBy"
]



// WEBPACK FOOTER //
// ./src/lodash-modules.js